<template>
    <div class="creditcard-overview" v-if="isCardPayment">
        <div class="creditcard-overview__icon">
            <img class="card-brand" v-if="paymentType === 8" src="@/assets/img/payment-types/multi-card.svg" />
            <CardBrand class="card-brand" v-else-if="paymentMethodImage" :brand="paymentMethodImage" tabindex="0" />
        </div>
        <div class="creditcard-overview__info">
            <div class="creditcard-overview__card-info" tabindex="0">
                <div class="creditcard-overview__last-digits">
                    <div>&bull;&bull;&bull;&bull;</div>
                    {{ cardNumberLast4Digits }}
                </div>

                <span v-text="$ml.get(getPaymentMethodTranslationParameterName())" />
            </div>

            <div class="creditcard-overview__price" tabindex="0">
                <span class="creditcard-overview__holder">{{ cardHolderName }}</span>

                <p v-if="isRecurringPayment || paymentType === 6 || paymentType === 2 || paymentType === 7 || paymentType === 4 || paymentType === 8">
                    1x
                    <span v-text="$ml.get('of')" />
                    R$ {{ installmentPrice }}
                </p>

                <p v-else>
                    {{ installments }}x
                    <span v-text="$ml.get('of')" />
                    R$ {{ installmentPrice }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
  import CardBrand from '@/components/CardBrand';
  import PaymentTypes from '@/models/PaymentTypes';
  import { mapGetters } from 'vuex';
  import translationParameterHelper from '@/config/lang/helpers/translationParameterHelper.js';

  export default {
    components: {
      CardBrand
    },

    computed: {
      ...mapGetters({
        cardNumberLast4Digits: 'cardPayment/getLast4DigitsFromCardNumber',
        cardHolderName: 'cardPayment/getCardHolderName',
        installments: 'payment/getInstallmentNumberOfPayments',
        installmentPrice: 'payment/getFormattedInstallmentPrice',
        selectedPaymentMethod: 'payment/getSelectedPaymentMethod',
        isRecurringPayment: 'recurrentPayment/isRecurringPayment',
        paymentType: 'payment/getSelectedPaymentTypeId'
      }),
      numberOfInstallments: {
        get: self => self.$store.getters['payment/getInstallmentNumberOfPayments'],
        set(value) { this.$store.commit('payment/setNumberOfInstallments', value); }
      },

      paymentMethodImage: self =>
        self.selectedPaymentMethod ? self.selectedPaymentMethod.Image : null,

      isCardPayment: self =>
        self.$store.state.payment.PaymentType != 100 &&
        self.$store.state.payment.PaymentType != 9 &&
        self.$store.state.payment.PaymentType != 101 &&
        self.$store.state.payment.PaymentType != 102 &&
        self.selectedPaymentMethod &&
        (self.selectedPaymentMethod.PaymentType == PaymentTypes.CREDIT_CARD ||
          self.selectedPaymentMethod.PaymentType == PaymentTypes.DEBIT_CARD ||
          self.selectedPaymentMethod.PaymentType == PaymentTypes.MULTIBENEFITS ||
          self.selectedPaymentMethod.PaymentType == PaymentTypes.VOUCHER),
    },


    methods: {
      getPaymentMethodTranslationParameterName() {
        return translationParameterHelper
          .getPaymentMethodTranslationParameterName(this.selectedPaymentMethod.PaymentType);
      }
    }
  };
</script>

<style lang="scss" scoped>

  .creditcard-overview {
      display: flex;
      align-items: center;

      &__info {
          width: 100%;
          overflow: hidden;
      }

      &__holder {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
      }

      &__card-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;

          span {
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
              color: #000;
          }
      }

      &__price {
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
              color: #000;
              margin: 0;
              text-align: right;
          }

          & > span {
              display: block;
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
              color: #000;
          }

          > * {
              flex: 1 0;
          }
      }

      &__icon {
          margin-right: 12px;
          
          @media screen and (min-width: 1025px) {
            margin-right: 20px;
          }

          img {}
      }

      &__last-digits {
          display: flex;
          align-items: center;
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
          color: #000;

          div:first-child {
              margin-right: 2px;
          }
      }

  }
</style>
